export const giftsItems = [
  {
    image:
      'https://dating-date-photos.s3.us-east-2.amazonaws.com/7-roses-bunch.png',
    title: 'Red Roses',
    description:
      'Perfect roses from Holland. The minimum quantity for an order is 7 roses.',
    priceCoins: 30,
    priceEur: 5,
    _id: 1,
  },
  {
    image:
      'https://dating-date-photos.s3.us-east-2.amazonaws.com/gifts+(1).jpg',
    title: 'Pink Roses',
    description:
      'Elegant white roses symbolizing purity. Minimum order: 7 roses.',
    priceCoins: 30,
    priceEur: 5,
    _id: 2,
  },
  {
    image:
      'https://dating-date-photos.s3.us-east-2.amazonaws.com/whiteroses.jpg',
    title: 'White Roses',
    description:
      'Perfect roses from Holland. The minimum quantity for an order is 7 roses. ',
    priceCoins: 30,
    priceEur: 5,
    _id: 3,
  },
  {
    image: 'https://dating-date-photos.s3.us-east-2.amazonaws.com/orchid.jpg',
    title: 'Orchid',
    description:
      'Orchids are commonly known to represent love, beauty and magnificence.',
    priceCoins: 260,
    priceEur: 45,
    _id: 4,
  },
  {
    image:
      'https://dating-date-photos.s3.us-east-2.amazonaws.com/potedroses.jpg',
    title: 'Potted roses',
    description:
      'Perfect for any occasion, these vibrant, blooming plants arrive in elegant containers, ready to bring charm and warmth to any space. A lasting gift that grows with care, potted roses symbolize love, gratitude, and celebration.',
    priceCoins: 225,
    priceEur: 38,
    _id: 5,
  },
  {
    image: 'https://dating-date-photos.s3.us-east-2.amazonaws.com/tulips.jpg',
    title: 'A bouquet of tulips',
    description:
      'A bouquet of fresh tulips will bring your lady bright and joyful moments and will remind her of spring, the season of love!',
    priceCoins: 400,
    priceEur: 65,
    _id: 6,
  },
  {
    image:
      'https://dating-date-photos.s3.us-east-2.amazonaws.com/11blueroses.jpg',
    title: '11 Blue Roses',
    description: 'Bouquet of 11 blue roses will make you woman the happiest',
    priceCoins: 470,
    priceEur: 72,
    _id: 7,
  },
  {
    image:
      'https://dating-date-photos.s3.us-east-2.amazonaws.com/51redroses.jpg',
    title: '51 Red Roses',
    description:
      'The most magnificent  impressive number of roses in this bouquet of 51 roses will a great gift for someone special',
    priceCoins: 965,
    priceEur: 155,
    _id: 8,
  },
  {
    image: 'https://dating-date-photos.s3.us-east-2.amazonaws.com/hannel5.jpg',
    title: 'Chanel 50 ml',
    description:
      'A wonderful fragrance for women!The composition sets off the femininity and elegance of the girl.',
    priceCoins: 750,
    priceEur: 140,
    _id: 9,
  },
  {
    image: 'https://dating-date-photos.s3.us-east-2.amazonaws.com/dior.jpg',
    title: 'Jadore Dior',
    description:
      'A sweet aroma  with the iconic feminine fragrance captures the sensuality and freshness of the most beautiful flowers! ',
    priceCoins: 750,
    priceEur: 140,
    _id: 10,
  },
  {
    image: 'https://dating-date-photos.s3.us-east-2.amazonaws.com/gabana.jpg',
    title: 'Dolce & Gabbana',
    description:
      'Dolce & Gabbana has captured an irresistibly joyful scent with this classic fragrance.',
    priceCoins: 650,
    priceEur: 120,
    _id: 11,
  },
  {
    image:
      'https://dating-date-photos.s3.us-east-2.amazonaws.com/fruitbasket.jpg',
    title: 'Fruit Basket',
    description:
      'Includes 6 kg fruit mixture :1 pineapple, grapes,  apples,  bananas, oranges,  kiwis,  pears.',
    priceCoins: 300,
    priceEur: 45,
    _id: 12,
  },
  {
    image:
      'https://dating-date-photos.s3.us-east-2.amazonaws.com/teabasket.jpg',
    title: 'Tea Basket',
    description:
      'Includes: few kinds of coffee and tea accompanied with chocolate bars and a jam jar.',
    priceCoins: 300,
    priceEur: 45,
    _id: 13,
  },
  {
    image:
      'https://dating-date-photos.s3.us-east-2.amazonaws.com/bathbasket.jpg',
    title: 'Bath Basket ',
    description:
      'Includes: shower gel, bath foam, body lotion, bast whisp, soap.',
    priceCoins: 280,
    priceEur: 45,
    _id: 14,
  },
  {
    image:
      'https://dating-date-photos.s3.us-east-2.amazonaws.com/tedybearbasket.jpg',
    title: 'Teddy Bear Basket',
    description:
      'Funny and amusing, toy with Red and pink mini Rose plant with chocolates  can be an excellent present for any event!',
    priceCoins: 450,
    priceEur: 70,
    _id: 15,
  },
  {
    image:
      'https://dating-date-photos.s3.us-east-2.amazonaws.com/ssweetbasket.jpg',
    title: 'Basket of Sweets',
    description:
      'Includes: 2 boxes of cookies,3 boxes of chocolate sweets,3 kinders.',
    priceCoins: 300,
    priceEur: 45,
    _id: 16,
  },
  {
    image:
      'https://dating-date-photos.s3.us-east-2.amazonaws.com/bountybasket.jpg',
    title: 'Bounty Basket',
    description:
      'Includes:Small teddy bear,Milk cream with coconut flakes Bounty,teacup,candies Bounty - 12 pcs,chocolate bar Milky Way minis - 4 pcs,cookies Oreo - 2 pcs, Marshmallow.',
    priceCoins: 450,
    priceEur: 70,
    _id: 17,
  },
  {
    image:
      'https://dating-date-photos.s3.us-east-2.amazonaws.com/kinderbasket.jpg',
    title: 'Kinder Basket',
    description:
      'A large basket of Kinders is an unforgettable taste of childhood. Contains 15 Kinder Surprise chocolate eggs.',
    priceCoins: 255,
    priceEur: 40,
    _id: 18,
  },
  {
    image:
      'https://dating-date-photos.s3.us-east-2.amazonaws.com/easterbasket.jpg',
    title: 'Easter Basket',
    description:
      '3 Easter cakes,1 big chocolate Easter bunny,1kg chocolate candies in the shape of eggs, 3 medium Chocolate eggs.',
    priceCoins: 450,
    priceEur: 70,
    _id: 19,
  },
  {
    image:
      'https://dating-date-photos.s3.us-east-2.amazonaws.com/sushibasket.jpg',
    title: 'Sushi Basket',
    description:
      'Includes:3 different types of sushi( 24 pieces) according to the ladys preferences.',
    priceCoins: 350,
    priceEur: 50,
    _id: 20,
  },
  {
    image:
      'https://dating-date-photos.s3.us-east-2.amazonaws.com/italianbasket.jpg',
    title: 'Italian  Basket',
    description:
      'Composition of the set: Pasta Garofalo Spaghetti 500g - 1pc; Casa Rinaldi Bolognese tomato sauce 190g - 1pc; Gran Moravia grated cheese 32% cor/mol 100g - 1pc; wine Riunite Lambrusco Emilia IGT Rosso 0.75l - 1 pc or according to the ladys preferences.',
    priceCoins: 350,
    priceEur: 50,
    _id: 21,
  },
  {
    image:
      'https://dating-date-photos.s3.us-east-2.amazonaws.com/foodbasket.jpg',
    title: 'Food Basket',
    description:
      'Includes: - 2 types of cheese; - 2 types of sausage,jamon 100g,1 loaf of bread ,1 red rose according to the ladys preferences',
    priceCoins: 450,
    priceEur: 70,
    _id: 22,
  },
  {
    image:
      'https://dating-date-photos.s3.us-east-2.amazonaws.com/berrybasket.jpg',
    title: 'Berry Basket',
    description:
      'Includes:raspberry200g,strawberry 1kg, blackberry125, blueberry 125g.',
    priceCoins: 450,
    priceEur: 70,
    _id: 23,
  },
  {
    image:
      'https://dating-date-photos.s3.us-east-2.amazonaws.com/fishbasket.jpg',
    title: 'Fish Basket',
    description:
      'includes:red fish in a vacuum pack, 1 tin of olives, 1cream cheese, 1- bread; -1 cucumbers300g ,1 olive oil;1package of fruit juice,50g ginger.',
    priceCoins: 450,
    priceEur: 70,
    _id: 24,
  },
  {
    image:
      'https://dating-date-photos.s3.us-east-2.amazonaws.com/vegetablebasket.jpg',
    title: 'Vegetable Basket',
    description:
      'Includes : 2kg Cucumbers, 2kg tomatoes ,1 cabbage,Salad "Green Country" leafy fresh-120 g,1bunch of parsley, 1 kg pepper.',
    priceCoins: 450,
    priceEur: 70,
    _id: 25,
  },
  {
    image:
      'https://dating-date-photos.s3.us-east-2.amazonaws.com/exoticbasket.jpg',
    title: 'Exotic Basket',
    description: 'Includes : mix tangerine and orange 6kg',
    priceCoins: 300,
    priceEur: 45,
    _id: 26,
  },
  {
    image:
      'https://dating-date-photos.s3.us-east-2.amazonaws.com/applebasket.jpg',
    title: 'Apple Basket',
    description: 'Includes: mix peaches ,pears ,apples 6 kg',
    priceCoins: 300,
    priceEur: 45,
    _id: 27,
  },
  {
    image:
      'https://dating-date-photos.s3.us-east-2.amazonaws.com/pizzabasket.jpg',
    title: 'Pizza Basket',
    description: 'Includes :2 types of pizza according to girls preference',
    priceCoins: 300,
    priceEur: 45,
    _id: 28,
  },
  {
    image: 'https://dating-date-photos.s3.us-east-2.amazonaws.com/blanket.jpg',
    title: 'Wool blanket',
    description:
      'Cozy up with our premium wool blankets – the perfect gift for warmth and comfort. Beautifully crafted and delivered straight to your doorstep, it’s a thoughtful way to wrap your loved ones in luxury.',
    priceCoins: 400,
    priceEur: 65,
    _id: 29,
  },
  {
    image: 'https://dating-date-photos.s3.us-east-2.amazonaws.com/barbie.jpg',
    title: 'Barbie Doll',
    description:
      'Surprise and delight with our Barbie Doll gift delivery! Discover the perfect gift for every Barbie fan, delivered straight to their door with love and care.',
    priceCoins: 300,
    priceEur: 45,
    _id: 30,
  },
  {
    image: 'https://dating-date-photos.s3.us-east-2.amazonaws.com/ball.jpg',
    title: 'Soccer Ball',
    description:
      'Score big with our Professional Soccer Ball – the perfect gift for athletes and sports enthusiasts. Premium quality, designed for top performance, and delivered right to their door!',
    priceCoins: 400,
    priceEur: 65,
    _id: 31,
  },
  {
    image: 'https://dating-date-photos.s3.us-east-2.amazonaws.com/lego.jpg',
    title: 'LEGO set',
    description:
      'Bring joy to your little builders with our curated LEGO gift delivery! Perfect for birthdays, holidays, or special surprises, our site offers a wide selection of LEGO sets designed to spark creativity and endless fun. Fast, reliable, and guaranteed to make kids smile!',
    priceCoins: 500,
    priceEur: 82,
    _id: 32,
  },
  {
    image: 'https://dating-date-photos.s3.us-east-2.amazonaws.com/robottoy.jpg',
    title: 'Robot Toy',
    description:
      'Surprise your loved ones with the perfect gift! Our high-quality Robot Toy delivers endless hours of fun and learning, combining interactive play with cutting-edge design. Ideal for kids and tech enthusiasts alike—order now for fast and reliable delivery!',
    priceCoins: 400,
    priceEur: 65,
    _id: 33,
  },
  {
    image:
      'https://dating-date-photos.s3.us-east-2.amazonaws.com/barbieandken.jpg',
    title: 'Barbie and Ken',
    description:
      'Bring the magic of Barbie and Ken to life with our exclusive gift set! Perfect for kids and collectors alike, this set includes beautifully detailed dolls, trendy outfits, and accessories for endless imaginative play. Delivered with care, it’s the ultimate surprise for Barbie fans of all ages!',
    priceCoins: 350,
    priceEur: 50,
    _id: 34,
  },
  {
    image: 'https://dating-date-photos.s3.us-east-2.amazonaws.com/legoset.jpg',
    title: 'LEGO',
    description:
      'This average Lego construction box will promotes the mental and physical development of children.',
    priceCoins: 470,
    priceEur: 70,
    _id: 35,
  },
  {
    image: 'https://dating-date-photos.s3.us-east-2.amazonaws.com/dolllol.jpg',
    title: 'Doll LOL',
    description:
      'Surprise and delight with Doll LOL Gift Delivery! Your go-to destination for unique and adorable LOL dolls, delivered straight to your loved ones doorsteps with love and care. Perfect for any occasion!',
    priceCoins: 400,
    priceEur: 65,
    _id: 36,
  },
  {
    image: 'https://dating-date-photos.s3.us-east-2.amazonaws.com/gym.jpg',
    title: 'Gym Gift Card',
    description:
      'Subscription to the gym for 8 sessions with a personal trainer.',
    priceCoins: 720,
    priceEur: 120,
    _id: 37,
  },
  {
    image: 'https://dating-date-photos.s3.us-east-2.amazonaws.com/solarium.jpg',
    title: 'Solarium',
    description: 'Subscription for 10 individual sessions to solarium.',
    priceCoins: 350,
    priceEur: 50,
    _id: 38,
  },
  {
    image: 'https://dating-date-photos.s3.us-east-2.amazonaws.com/manicure.jpg',
    title: 'Manicure-Pedicure',
    description: 'Subscription for manicure-pedicure in the salon.',
    priceCoins: 400,
    priceEur: 65,
    _id: 39,
  },
  {
    image: 'https://dating-date-photos.s3.us-east-2.amazonaws.com/spa.jpg',
    title: 'Spa treatments',
    description: 'Subscription for spa treatments in the salon.',
    priceCoins: 800,
    priceEur: 160,
    _id: 40,
  },
  {
    image: 'https://dating-date-photos.s3.us-east-2.amazonaws.com/massage.jpg',
    title: 'Massage',
    description: 'Subscription for massage in the salon.',
    priceCoins: 300,
    priceEur: 45,
    _id: 41,
  },
  {
    image: 'https://dating-date-photos.s3.us-east-2.amazonaws.com/swimpool.jpg',
    title: 'Swimming pool',
    description: 'Subscription for 6 visits to the swimming pool.',
    priceCoins: 450,
    priceEur: 65,
    _id: 42,
  },
  {
    image:
      'https://dating-date-photos.s3.us-east-2.amazonaws.com/horseriding.jpg',
    title: 'Horse Riding',
    description: 'Horse riding Gift Certificates for 1 session (2 hours)',
    priceCoins: 300,
    priceEur: 45,
    _id: 43,
  },
  {
    image:
      'https://dating-date-photos.s3.us-east-2.amazonaws.com/photosession.jpg',
    title: 'Photo Session',
    description: 'Professional Photo Session for your lady .',
    priceCoins: 650,
    priceEur: 120,
    _id: 44,
  },
  {
    image:
      'https://dating-date-photos.s3.us-east-2.amazonaws.com/englishlessons.jpg',
    title: 'English Course',
    description:
      'Individual lessons in accordance with your personal schedule for 3 months! Help your girl to learn English better!',
    priceCoins: 1250,
    priceEur: 200,
    _id: 45,
  },

  {
    image:
      'https://dating-date-photos.s3.us-east-2.amazonaws.com/tedyunderwear.jpg',
    title: 'Teddy Underwear',
    description:
      'Teddy bear and exquisite underwear. You can make your lady feel special.',
    priceCoins: 750,
    priceEur: 125,
    _id: 48,
  },

  {
    image:
      'https://dating-date-photos.s3.us-east-2.amazonaws.com/neglestockings.jpg',
    title: 'Negligee',
    description:
      'Sexual and sensual Negligee and stockings. The best gift to make your lady feel beloved.',
    priceCoins: 600,
    priceEur: 100,
    _id: 51,
  },
  {
    image:
      'https://dating-date-photos.s3.us-east-2.amazonaws.com/hairdryer.jpg',
    title: 'Hair Dryer',
    description:
      'Includes:Mini Hair dryer, shampoo and protection lotion for hair.',
    priceCoins: 450,
    priceEur: 65,
    _id: 52,
  },

  {
    image: 'https://dating-date-photos.s3.us-east-2.amazonaws.com/tedybear.jpg',
    title: 'Teddy Bear',
    description:
      'Surprise your loved ones with a cuddly, oversized companion! Our Giant Teddy Bear is the ultimate gift for any occasion, offering soft hugs and endless charm. Available for fast, reliable online delivery to your doorstep',
    priceCoins: 500,
    priceEur: 75,
    _id: 54,
  },

  {
    image: 'https://dating-date-photos.s3.us-east-2.amazonaws.com/bathrobe.jpg',
    title: 'Bathrobe',
    description:
      'Wrap yourself in comfort and luxury with our premium bathrobes. Perfect for lounging or post-shower relaxation, our bathrobes combine softness, style, and durability for an indulgent experience delivered right to your door.',
    priceCoins: 450,
    priceEur: 65,
    _id: 57,
  },
  {
    image: 'https://dating-date-photos.s3.us-east-2.amazonaws.com/pajamas.jpg',
    title: 'Pajamas',
    description:
      'Choose the best pajamas Victoria Secret  for your girl to stay cozy all season.',
    priceCoins: 1250,
    priceEur: 200,
    _id: 58,
  },
  {
    image: 'https://dating-date-photos.s3.us-east-2.amazonaws.com/slippers.jpg',
    title: 'Slippers',
    description:
      'Show attention and please your beloved woman or best friend with high-quality knitted pajamas with slippers . This is a warm gift  from Victoria s Secret will warm her body',
    priceCoins: 1500,
    priceEur: 300,
    _id: 59,
  },
  {
    image:
      'https://dating-date-photos.s3.us-east-2.amazonaws.com/swimmingsuit.jpg',
    title: 'Swimming Suits',
    description:
      'Shop stylish and comfortable swimming suits for all ages and body types! Perfect for beach days, pool parties, or water sports, our collection features trendy designs and high-quality materials to keep you looking great and feeling confident. Fast online delivery and a variety of sizes available!',
    priceCoins: 625,
    priceEur: 95,
    _id: 60,
  },
  {
    image:
      'https://dating-date-photos.s3.us-east-2.amazonaws.com/skinnyfit.jpg',
    title: 'Skinny Fit',
    description: 'You will see long and skinny legs of your beloved lady. ',
    priceCoins: 750,
    priceEur: 125,
    _id: 61,
  },
  {
    image: 'https://dating-date-photos.s3.us-east-2.amazonaws.com/contacts.jpg',
    title: 'Contacts',
    description:
      'Purchase personal Information of the lady. It includes: email address, phone number with Viber or WhatsApp. ',
    priceCoins: 400,
    priceEur: 65,
    _id: 62,
  },
  {
    image: 'https://dating-date-photos.s3.us-east-2.amazonaws.com/giftbox.jpg',
    title: 'Gift Box',
    description:
      'Warm socks with New Years print - 2 pcs Raffaello candies - 10 pcs,chocolate spread Twix,scented candle,two kinders,3  bars of chocolate,New Years toy made of wood,a mug with a New Years print ',
    priceCoins: 625,
    priceEur: 95,
    _id: 63,
  },
];
